import { usePreferencesStore, type StudyMode } from "@/preferences-store";

export type LearningView = "path" | "list";

// A URL preserva histórico e retorno do player no modo interativo.
// O modo tradicional mantém a lista, inclusive em links antigos do percurso.
export function courseLearningSearch(search: Record<string, unknown>): { view?: LearningView } {
  return { view: search.view === "path" || search.view === "list" ? search.view : undefined };
}

export function resolveLearningView(view: unknown, studyMode: StudyMode): LearningView {
  if (studyMode === "traditional") return "list";
  return view === "list" ? "list" : "path";
}

export function useLearningView(view: unknown): LearningView {
  const studyMode = usePreferencesStore((state) => state.studyMode);
  return resolveLearningView(view, studyMode);
}
